import { ADMIN_ROLES } from '@avanta/shared/constants/admins';
import { UserType } from '@avanta/shared/constants/users';
import { type AdminRole } from '@avanta/shared/types/enterprises';
import {
  ADMIN_NAV_ROUTES,
  BILLING_NAV_ROUTES,
  HOME_NAV_ROUTE,
  MANAGER_NAV_ROUTES,
  type NavRoute,
} from 'constants/nav';

export const getSidebarRoutes = (userType: UserType, role?: AdminRole): NavRoute[] => {
  if (
    (userType === UserType.ADMIN_ENTERPRISE && role === ADMIN_ROLES.ADMIN) ||
    userType === UserType.ENTERPRISE
  ) {
    return ADMIN_NAV_ROUTES;
  }

  if (userType === UserType.ADMIN_ENTERPRISE && role === ADMIN_ROLES.MANAGER) {
    return [HOME_NAV_ROUTE, ...MANAGER_NAV_ROUTES];
  }

  if (userType === UserType.ADMIN_ENTERPRISE && role === ADMIN_ROLES.BILLING) {
    return [HOME_NAV_ROUTE, ...BILLING_NAV_ROUTES];
  }

  return [HOME_NAV_ROUTE];
};
